import {AnticipationRequest, IReceivable} from "./punctualAnticipation/anticipation/types";


const formatToISOString = (date: string | Date): string => {
  const d = new Date(date);
  if (isNaN(d.getTime())) {
    throw new Error(`Data inválida: ${date}`);
  }
  return d.toISOString(); // formato ISO 8601
};


export const formatProduct = (value: number): string => {
  if(value == 1){
    return 'Pos Garantida'
  }
  return 'Pos Garantida'
}

export const mapReceivablesToAnticipationRequests = (
  receivables: IReceivable[]
): AnticipationRequest[] => {
  return receivables.map((receivable) => ({
    nsu: receivable.acquirerNsu,
    authorization: receivable.authorizationNumber,
    merchantId: receivable.merchant,
    currentParcel: receivable.currentParcel,
    paymentDate: formatToISOString(receivable.paymentDate),
    anticipationFee: receivable.anticipationFee as number,
    liquidValue: receivable.liquidValue,
    receiveDate: formatToISOString(receivable.receiveDate),
    newReceiveDate: formatToISOString(receivable.newReceiveDate as string),
    anticipationDate: formatToISOString(receivable.anticipationDate as string),
  }));
};
